PageApp.Ent.ExchangeRatesModel = Backbone.Collection.extend({
  model: PageApp.Ent.ExchangeRate,
  initialize: function () {
  },
  extract: function (exchangeRates, silently) {
    this.set(exchangeRates || {}, { silent: silently })
  }
})
